export function formatCurrency(currency: number): string {
    const formatedCurrency = `${(currency).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$& ')} kr`;

    return parseInt(formatedCurrency) % 1 > 0
        ? formatedCurrency
        : formatedCurrency.replace(".00", "");
}